import { Provider, inject } from '@angular/core';
import { environment } from 'src/environments/environment';

import { MerchantProvisionRepository } from '@app/domain/ports/tpv/merchant-provision.repository';
import { MerchantProvisionRemoteDataSource } from '@app/data/data-sources/remote/tpv/merchant-provision-remote.data-source';
import { MerchantProvisionMockDataSource } from '@app/data/data-sources/mock/tpv/merchant-provision-mock.data-source';

import { MerchantBulkRepository } from '@app/domain/ports/tpv/merchant-bulk.repository';
import { MerchantBulkRemoteDataSource } from '@app/data/data-sources/remote/tpv/merchant-bulk-remote.data-source';
import { MerchantBulkMockDataSource } from '@app/data/data-sources/mock/tpv/merchant-bulk-mock.data-source';

import { MerchantOperationRepository } from '@app/domain/ports/tpv/merchant-operation.repository';
import { MerchantOperationRemoteDataSource } from '@app/data/data-sources/remote/tpv/merchant-operation-remote.data-source';
import { MerchantOperationMockDataSource } from '@app/data/data-sources/mock/tpv/merchant-operation-mock.data-source';

import { MerchantRepository } from '@app/domain/ports/tpv/merchant.repository';
import { MerchantRemoteDataSource } from '@app/data/data-sources/remote/tpv/merchant-remote.data-source';
import { MerchantMockDataSource } from '@app/data/data-sources/mock/tpv/merchant-mock.data-source';

import { TransactionRepository } from '@app/domain/ports/tpv/transaction.repository';
import { TransactionRemoteDataSource } from '@app/data/data-sources/remote/tpv/transaction-remote.data-source';
import { TransactionMockDataSource } from '@app/data/data-sources/mock/tpv/transaction-mock.data-source';

import { DispersionRepository } from '@app/domain/ports/tpv/dispersion.repository';
import { DispersionRemoteDataSource } from '@app/data/data-sources/remote/tpv/dispersion-remote.data-source';
import { DispersionMockDataSource } from '@app/data/data-sources/mock/tpv/dispersion-mock.data-source';
import { MemphisOperatorRepository } from '@app/domain/ports/tpv/memphis-operator.repository';
import { MemphisOperatorRemoteDataSource } from '@app/data/data-sources/remote/tpv/memphis-operator-remote.data-source';
import { MemphisOperatorMockDataSource } from '@app/data/data-sources/mock/tpv/memphis-operator-mock.data-source';

import { SettlementRepository } from '@app/domain/ports/tpv/settlement.repository';
import { SettlementRemoteDataSource } from '@app/data/data-sources/remote/tpv/settlement-remote.data-source';
import { SettlementMockDataSource } from '@app/data/data-sources/mock/tpv/settlement-mock.data-source';

import { TerminalRepository } from '@app/domain/ports/tpv/terminal.repository';
import { TerminalRemoteDataSource } from '@app/data/data-sources/remote/tpv/terminal-remote.data-source';
import { TerminalMockDataSource } from '@app/data/data-sources/mock/tpv/terminal-mock.data-source';

import { TerminalCatalogRepository } from '@app/domain/ports/tpv/terminal-catalog.repository';
import { TerminalCatalogRemoteDataSource } from '@app/data/data-sources/remote/tpv/terminal-catalog-remote.data-source';
import { TerminalCatalogMockDataSource } from '@app/data/data-sources/mock/tpv/terminal-catalog-mock.data-source';

import { MerchantLifecycleRepository } from '@app/domain/ports/tpv/merchant-lifecycle.repository';
import { MerchantLifecycleRemoteDataSource } from '@app/data/data-sources/remote/tpv/merchant-lifecycle-remote.data-source';
import { MerchantLifecycleMockDataSource } from '@app/data/data-sources/mock/tpv/merchant-lifecycle-mock.data-source';

import { TerminalRegistrationRepository } from '@app/domain/ports/tpv/terminal-registration.repository';
import { TerminalRegistrationRemoteDataSource } from '@app/data/data-sources/remote/tpv/terminal-registration-remote.data-source';
import { TerminalRegistrationMockDataSource } from '@app/data/data-sources/mock/tpv/terminal-registration-mock.data-source';

import { TerminalNotificationRepository } from '@app/domain/ports/tpv/terminal-notification.repository';
import { TerminalNotificationRemoteDataSource } from '@app/data/data-sources/remote/tpv/terminal-notification-remote.data-source';
import { TerminalNotificationMockDataSource } from '@app/data/data-sources/mock/tpv/terminal-notification-mock.data-source';

import { CompanyProvisionRepository } from '@app/domain/ports/tpv/company-provision.repository';
import { CompanyProvisionRemoteDataSource } from '@app/data/data-sources/remote/tpv/company-provision-remote.data-source';
import { CompanyProvisionMockDataSource } from '@app/data/data-sources/mock/tpv/company-provision-mock.data-source';

import { CompanyDirectoryRepository } from '@app/domain/ports/tpv/company-directory.repository';
import { CompanyDirectoryRemoteDataSource } from '@app/data/data-sources/remote/tpv/company-directory-remote.data-source';
import { CompanyDirectoryMockDataSource } from '@app/data/data-sources/mock/tpv/company-directory-mock.data-source';

import { BusinessUnitDirectoryRepository } from '@app/domain/ports/tpv/business-unit.repository';
import { BusinessUnitRemoteDataSource } from '@app/data/data-sources/remote/tpv/business-unit-remote.data-source';
import { BusinessUnitMockDataSource } from '@app/data/data-sources/mock/tpv/business-unit-mock.data-source';

import { MsiRepository } from '@app/domain/ports/tpv/msi.repository';
import { MsiRemoteDataSource } from '@app/data/data-sources/remote/tpv/msi-remote.data-source';
import { MsiMockDataSource } from '@app/data/data-sources/mock/tpv/msi-mock.data-source';

import { CompanyLifecycleRepository } from '@app/domain/ports/tpv/company-lifecycle.repository';
import { CompanyLifecycleRemoteDataSource } from '@app/data/data-sources/remote/tpv/company-lifecycle-remote.data-source';
import { CompanyLifecycleMockDataSource } from '@app/data/data-sources/mock/tpv/company-lifecycle-mock.data-source';

import { TerminalLifecycleRepository } from '@app/domain/ports/tpv/terminal-lifecycle.repository';
import { TerminalLifecycleRemoteDataSource } from '@app/data/data-sources/remote/tpv/terminal-lifecycle-remote.data-source';
import { TerminalLifecycleMockDataSource } from '@app/data/data-sources/mock/tpv/terminal-lifecycle-mock.data-source';

import { VoucherRepository } from '@app/domain/ports/tpv/voucher.repository';
import { VoucherRemoteDataSource } from '@app/data/data-sources/remote/tpv/voucher-remote.data-source';
import { VoucherMockDataSource } from '@app/data/data-sources/mock/tpv/voucher-mock.data-source';

import { TpvDashboardRepository } from '@app/domain/ports/tpv/tpv-dashboard.repository';
import { TpvDashboardRemoteDataSource } from '@app/data/data-sources/remote/tpv/dashboard-summary-remote.data-source';
import { TpvDashboardMockDataSource } from '@app/data/data-sources/mock/tpv/dashboard-summary-mock.data-source';

import { TpvUserAccessRepository } from '@app/domain/ports/tpv/tpv-user-access.repository';
import { TpvUserAccessRemoteDataSource } from '@app/data/data-sources/remote/tpv/user-access-remote.data-source';
import { TpvUserAccessMockDataSource } from '@app/data/data-sources/mock/tpv/user-access-mock.data-source';

import { GestorRepository } from '@app/domain/ports/tpv/gestor.repository';
import { GestorRemoteDataSource } from '@app/data/data-sources/remote/tpv/gestor-remote.data-source';
import { GestorMockDataSource } from '@app/data/data-sources/mock/tpv/gestor-mock.data-source';

import { TpvOperatorRepository } from '@app/domain/ports/tpv/tpv-operator.repository';
import { TpvOperatorRemoteDataSource } from '@app/data/data-sources/remote/tpv/tpv-operator-remote.data-source';
import { TpvOperatorMockDataSource } from '@app/data/data-sources/mock/tpv/tpv-operator-mock.data-source';

import { UnitRepository } from '@app/domain/ports/tpv/unit.repository';
import { UnitRemoteDataSource } from '@app/data/data-sources/remote/tpv/unit-remote.data-source';
import { UnitMockDataSource } from '@app/data/data-sources/mock/tpv/unit-mock.data-source';

import { CommissionsRepository } from '@app/domain/ports/tpv/commissions.repository';
import { CommissionsRemoteDataSource } from '@app/data/data-sources/remote/tpv/commissions-remote.data-source';
import { CommissionsMockDataSource } from '@app/data/data-sources/mock/tpv/commissions-mock.data-source';

import { TasasRepository } from '@app/domain/ports/tpv/tasas.repository';
import { TasasUseCase } from '@app/domain/use-cases/tpv/tasas.use-case';
import { TasasRemoteDataSource } from '@app/data/data-sources/remote/tpv/tasas-remote.data-source';
import { TasasMockDataSource } from '@app/data/data-sources/mock/tpv/tasas-mock.data-source';

import { TpvReportRepository } from '@app/domain/ports/tpv/tpv-report.repository';
import { TpvReportRemoteDataSource } from '@app/data/data-sources/remote/tpv/tpv-report-remote.data-source';
import { TpvReportMockDataSource } from '@app/data/data-sources/mock/tpv/tpv-report-mock.data-source';

/**
 * Providers del TPV REST nuevo (`api/v1/tpv/`).
 *
 * `environment.tpvUseMocks` decide entre datos mock (pruebas sin backend) y el
 * data-source HTTP real. Mismo patrón para provisión y las 5 lecturas
 * (merchants, transactions, dispersions, settlements, terminals).
 */
const useMocks = environment.tpvUseMocks === true;

export const TPV_REST_PROVIDERS: Provider[] = [
  {
    provide: MerchantProvisionRepository,
    useClass: useMocks ? MerchantProvisionMockDataSource : MerchantProvisionRemoteDataSource,
  },
  // Alta masiva de comercios + plantilla (§4 y §5, IsAdmin)
  {
    provide: MerchantBulkRepository,
    useClass: useMocks ? MerchantBulkMockDataSource : MerchantBulkRemoteDataSource,
  },
  // Datos de operación del comercio: lectura (§2) y alta (§3)
  {
    provide: MerchantOperationRepository,
    useClass: useMocks ? MerchantOperationMockDataSource : MerchantOperationRemoteDataSource,
  },
  {
    provide: MerchantRepository,
    useClass: useMocks ? MerchantMockDataSource : MerchantRemoteDataSource,
  },
  {
    provide: TransactionRepository,
    useClass: useMocks ? TransactionMockDataSource : TransactionRemoteDataSource,
  },
  {
    provide: DispersionRepository,
    useClass: useMocks ? DispersionMockDataSource : DispersionRemoteDataSource,
  },
  {
    provide: MemphisOperatorRepository,
    useClass: useMocks ? MemphisOperatorMockDataSource : MemphisOperatorRemoteDataSource,
  },
  {
    provide: SettlementRepository,
    useClass: useMocks ? SettlementMockDataSource : SettlementRemoteDataSource,
  },
  {
    provide: TerminalRepository,
    useClass: useMocks ? TerminalMockDataSource : TerminalRemoteDataSource,
  },
  // Catálogo de terminales del filtro "N° Terminal" de Transacciones (feature
  // 151): comercio OPCIONAL, puerto propio para no tocar `TerminalRepository`.
  {
    provide: TerminalCatalogRepository,
    useClass: useMocks ? TerminalCatalogMockDataSource : TerminalCatalogRemoteDataSource,
  },
  // Escrituras (IsAdmin): ciclo de vida del comercio (§3) y registro de terminal (§4)
  {
    provide: MerchantLifecycleRepository,
    useClass: useMocks ? MerchantLifecycleMockDataSource : MerchantLifecycleRemoteDataSource,
  },
  {
    provide: TerminalRegistrationRepository,
    useClass: useMocks ? TerminalRegistrationMockDataSource : TerminalRegistrationRemoteDataSource,
  },
  // Notificación/credenciales a terminal (§6, ManageTpvTerminalPermission)
  {
    provide: TerminalNotificationRepository,
    useClass: useMocks ? TerminalNotificationMockDataSource : TerminalNotificationRemoteDataSource,
  },
  // Multi-company (§6): provisión de una Company org en el TPV (IsAdmin)
  {
    provide: CompanyProvisionRepository,
    useClass: useMocks ? CompanyProvisionMockDataSource : CompanyProvisionRemoteDataSource,
  },
  // Directorios (lecturas) confirmados en la fachada por el Postman
  {
    provide: CompanyDirectoryRepository,
    useClass: useMocks ? CompanyDirectoryMockDataSource : CompanyDirectoryRemoteDataSource,
  },
  {
    provide: BusinessUnitDirectoryRepository,
    useClass: useMocks ? BusinessUnitMockDataSource : BusinessUnitRemoteDataSource,
  },
  {
    provide: MsiRepository,
    useClass: useMocks ? MsiMockDataSource : MsiRemoteDataSource,
  },
  // Escrituras (IsAdmin): ciclo de vida company/unit y terminal
  {
    provide: CompanyLifecycleRepository,
    useClass: useMocks ? CompanyLifecycleMockDataSource : CompanyLifecycleRemoteDataSource,
  },
  {
    provide: TerminalLifecycleRepository,
    useClass: useMocks ? TerminalLifecycleMockDataSource : TerminalLifecycleRemoteDataSource,
  },
  // Comprobantes (vouchers)
  {
    provide: VoucherRepository,
    useClass: useMocks ? VoucherMockDataSource : VoucherRemoteDataSource,
  },
  // Dashboard de TPV (`GET /api/v1/tpv/dashboard/`). Validado en stage el
  // 2026-06-13; usa el mismo toggle `tpvUseMocks` que el resto del TPV.
  {
    provide: TpvDashboardRepository,
    useClass: useMocks ? TpvDashboardMockDataSource : TpvDashboardRemoteDataSource,
  },
  // Árbol de accesos TPV del usuario (`GET /api/v1/tpv/user/access/`) para el
  // selector de comercio (drill-down) del dashboard.
  {
    provide: TpvUserAccessRepository,
    useClass: useMocks ? TpvUserAccessMockDataSource : TpvUserAccessRemoteDataSource,
  },
  // Gestores genéricos (`/api/gestor/*`, API principal, IsAdminUser): alta,
  // consulta y edición de gestores sobre cuentas existentes (SPEI/Cards/TPV).
  {
    provide: GestorRepository,
    useClass: useMocks ? GestorMockDataSource : GestorRemoteDataSource,
  },
  // Operadores TPV nativos (`POST /api/v1/tpv/companies/<id>/operators/`): crea el
  // usuario desde cero con scoping opcional por comercio.
  {
    provide: TpvOperatorRepository,
    useClass: useMocks ? TpvOperatorMockDataSource : TpvOperatorRemoteDataSource,
  },
  // Multi-unidad (§2): CRUD de unidades de negocio por empresa (IsAdmin)
  {
    provide: UnitRepository,
    useClass: useMocks ? UnitMockDataSource : UnitRemoteDataSource,
  },
  // Comisiones (§1): CRUD unificado en 3 niveles (manage-level)
  {
    provide: CommissionsRepository,
    useClass: useMocks ? CommissionsMockDataSource : CommissionsRemoteDataSource,
  },
  // Tasas de comisión por eje (contrato §1): `/tasa/` en empresa/UN/comercio.
  // Reemplaza a los campos gobernados de `/commissions/` (RN-01, §4).
  {
    provide: TasasRepository,
    useClass: useMocks ? TasasMockDataSource : TasasRemoteDataSource,
  },
  // Use-case puro de dominio (sin `@Injectable`): la inyección del repositorio
  // se hace aquí con `useFactory` para respetar Clean Architecture — el use-case
  // vive en `domain/` y no puede depender de Angular.
  {
    provide: TasasUseCase,
    useFactory: () => new TasasUseCase(inject(TasasRepository)),
  },
  // Reportes descargables (transacciones/comercios/empresas/unidades): el backend
  // genera el archivo en Base64 respondiendo a los filtros activos (`.../report/`).
  {
    provide: TpvReportRepository,
    useClass: useMocks ? TpvReportMockDataSource : TpvReportRemoteDataSource,
  },
];
